import { Avatar, AvatarFallback, AvatarImage } from "@/shadcn/ui/avatar";

import { AvatarShimmer } from "../common/AvatarShimmer";

export default function NotificationWithComedianAvatar({
  comedianImgUrl,
  comedianName,
  text,
  size = "sm",
}: {
  comedianImgUrl: string;
  comedianName: string;
  text: string;
  size?: "sm" | "md";
}) {
  return (
    <span className="flex items-center gap-x-3">
      <Avatar
        className={size === "sm" ? "w-10 h-10" : "h-10 w-10 md:w-16 md:h-16"}
      >
        <AvatarImage
          src={comedianImgUrl}
          alt={"Comedian"}
          className="object-cover object-top block"
        />
        <AvatarFallback>
          <AvatarShimmer />
        </AvatarFallback>
      </Avatar>
      <span>
        <span
          className={
            size === "md"
              ? "font-bold pl-2 md:pl-4 text-sm md:text-lg"
              : "font-bold text-lg"
          }
        >
          {comedianName + " "}
        </span>
        {text}
      </span>
    </span>
  );
}
